import { memo } from 'react';

import { merge } from '@/components';
import { Text } from '@/components/core';
import { SaveIcon } from '@/components/icons';
import { DivProps, OmitChildren } from '@/utils';

export type SaveProps = OmitChildren<DivProps> & {
  message: string;
};

const ISave = ({ message, className, ...rest }: SaveProps) => {
  return (
    <div className={merge('group/save gap-sm flex h-full w-full items-center justify-center', className)} {...rest}>
      <SaveIcon />
      <Text slot="description">{message}</Text>
    </div>
  );
};

export const Save = memo(ISave) as typeof ISave;
